// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__OVuq2","header":"ClearentDisclaimer_header__k0jcc","inner":"ClearentDisclaimer_inner__VD86y"};